import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useScope, useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import CustomerTitleItems from '@sophocles/components/App/CustomerTitleItems';
import TitleBar from '@sophocles/components/App/TitleBar';

import AlarmLiveReportGrid from './components/AlarmLiveReportGrid';

function CustomerAlarmLiveReportView(props) {
  const { t } = useTranslation();
  const { customer } = useScope();
  const { user } = useUser();
  const {
    match: { params },
  } = props;

  const baseSiteGroupLink = `/c/${params.cust_id}/plant/`;

  return (
    <AppNav flex notFullHeight page="customer_reports" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar
          showBackButton
          title={t('reports.alarmAndMaintenanceLiveSummary')}
          items={<CustomerTitleItems user={user} customer={customer} params={params} page="reports" />}
        />
        <AlarmLiveReportGrid baseSiteGroupLink={baseSiteGroupLink} />
      </Box>
    </AppNav>
  );
}

export default CustomerAlarmLiveReportView;
